function Navbar() {
  return (
    <header className="navbar_header">
      <div className="navbar_div">
        <section>
          <span className="navbar_logo">CrackIt</span>
        </section>
        <section className="navbar_right">
          {/* <button>SignIn</button>
          <button>SignUp</button> */}
        </section>
      </div>
    </header>
  );
}
export default Navbar;
